import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CurrencyPipe} from "@angular/common";

@Component({
  selector: 'app-sales-quotas-installment',
  templateUrl: './sales-quotas-installment.component.html',
})
export class SalesQuotasInstallmentComponent {
  @Input() installment: any;
  @Input() installmentBig: any;
  @Input() viewPaymentAdd = false;
  @Output() step = new EventEmitter();

  constructor( private currencyPipe: CurrencyPipe) {
  }

  onNavigateSelectedQuotes(value: any){
    this.step.emit(value);
  }

  onReturnLabelInstallment(pay: any){
    return `${this.currencyPipe.transform(pay)}`;
  }
}
